<script setup lang="ts">
  import { computed } from 'vue';
  import { useBranchLogo } from '@/entities/Branch';
  import { QualityRecordModal } from '@/shared/ui';

  /**
   * Shell of the two read only modals of a record. It is the same shell as the
   * document modals, so the two screens cannot drift apart: the only differences
   * are the pill, which names a `Registro`, and the code of the record in the
   * place of the document prefix.
   */
  const props = withDefaults(
    defineProps<{
      modalTitle: string;
      /** Title inside the institutional header, in the upper case of the design. */
      formTitle: string;
      /** Code of the quality record form itself, not of the record being consulted. */
      formCode: string;
      /** Revision of the form, already labelled, for instance `REV.03`. */
      formRevisionLabel: string;
      /** Code of the record being consulted, for instance `RQ18.3`. */
      code: string;
      printCompact?: boolean;
    }>(),
    {
      printCompact: false,
    }
  );

  const emit = defineEmits<{
    close: [];
  }>();

  const { currentLogoUrl, handleLogoError, resolvePrintableLogoSrc } = useBranchLogo();

  const documentInfo = computed(() => ({
    code: props.formCode,
    revision: props.formRevisionLabel,
    documentNumber: props.formCode,
    documentPrefix: props.code,
  }));
</script>

<template>
  <QualityRecordModal
    :modal-title="modalTitle"
    :form-title="formTitle"
    :document-info="documentInfo"
    pill-label="Registro"
    :compact="printCompact"
    :logo-url="currentLogoUrl"
    :resolve-logo-src="resolvePrintableLogoSrc"
    @logo-error="handleLogoError"
    @close="emit('close')"
  >
    <slot />
  </QualityRecordModal>
</template>
